export default {
  allinone: {
    bannerTitle: '软硬一体化',
    title: '软硬一体化方案',
    info:`
    龙讯旷腾除了提供PWmat软件授权，还提供预装龙讯旷腾各种软件产品的一体机，
    提供软硬结合的一体化方案，其中包括智能计算CPU一体机QStation、单机版Mstation和集群版Mcluster。
    均配置好PWmat、Q-Flow、Q-Studio、PWkit， 以及机器管理和作业调度软件，用户可开箱即用。
    同时，龙讯旷腾自建了超算云Mcloud， 提供机时租赁服务，用户直接租机时即 使用龙讯的各种软件产品。
    `,

    qstationT: '原子尺度材料智能计算一体机',
    qstationInfo:`
    QStation是一款革命性的CPU一体机，专为前沿材料科学研究打造。它将复杂的原子尺度建模与高性能模拟计算无缝集成，
    是一款实验小组与计算新手也能用上的workstation，为您开启探索材料微观世界的新维度。QStation配备精准建模功能，
    可以轻松构建从小分子、完美晶体到纳米管、团簇乃至量子输运器件的多样化原子模型；智慧组合模式可以实现快而准的模型生成功能，
    助您自如设计例如：界面结构、表面吸附体系、无序结构、单原子催化系统等关键科研模型；同时配备的智能优化功能已集成当前最前沿机器学习力场，
    赋予模型更贴近真实物理的构型与能量状态；智能计算工作流可一键启航，根据您精心构建的模型参数，
    QStation可以智能生成最优化的计算设置与高效工作流，大幅简化繁琐的配置过程；
    QStation能够深入探索材料的电子结构、光学响应、输运行为、力学强度及热学性质等核心物理特性，揭示材料的本质规律；
    专业计算结果后处理，可以将数据转化为清晰直观的图表、图谱与关键数据，让科研成果跃然眼前。
    `,
    qstationT2: '下面的表格展示了 Qstation 的硬件配置',

    mstationT: '单机版',
    mstationInfo:`
    单机版Mstation为双路4U服务器，包含两颗CPU（14x2=28核心）和4块GPU卡，
    同时预装PWmat、Q-Flow、Q-Studio和PWkit软件，也可以根据用户需求安装各种开源软件。
    两台单机版Mstation可以通过直接ib网线互联组成轻量化的集群，相比集群版Mcluster，
    其不需要管理节点及inifiniband交换机等设备，具有高性价比的特点，而且可以进行大体系计算。
    `,
    mstationT2: '下面的表格展示了Mstation和双机互联版的Mstation的硬件配置',
    mstationT2R0C1: '硬件',
    mstationT2R0C2: '单机版 Mstation',
    mstationT2R0C3: '双机互联版 Mstation',
    mstationT2R1C2: '两颗CPU (14x2=28核心)',
    mstationT2R1C3: '每台机器两颗CPU（14x2x2=56）',
    mstationT2R2C2: '4 块 NVIDIA ® GTX 3080Ti/3090',
    mstationT2R2C3: '8 块 NVIDIA ® GTX 3080Ti/3090',
    mstationT2R3C1: '内存',
    mstationT2R3C2: '最大512GB DDR4',
    mstationT2R3C3: '最大512GB DDR4',
    mstationT2R4C1: '操作系统',
    mstationT2R5C1: 'IB交换网络',
    mstationT2R5C3: '有',
    mcluster: '集群版 Mcluster',
    mclusterP1: `
          MCluster由多台Mstation、存储服务器以及一个管理节点组成，每台Mstation之间通过超高速Infiniband网络进行数据传输。
          Mcloud同样预装PWmat、Q-Flow、Q-Studio和PWkit软件，同时也安装了集群管理软件XCAT,作业调度软件slurm等。部署PWmat后的“MCluster”在材料计算领域用途广泛，最典型的一
          个应用就是材料基因组计算，对于材料基因组开发，高通量计算、数据库建设、材料搜索都有极大的助益。目前最成功的案例就是北京大学深圳研究生院通过MCluster平台产生的材料数据库。
          在龙讯的帮助下，北大深圳研究生院建立了世界上首个HSE（杂化泛函）材料能带数据库。通过MCluster平台，每周能够为数据库产生超过一千个晶体结构的数据。MCluster+PWmat平台加上
          相对应的自动化工作流框架, 使这一套系统成为完成材料基因组项目的不可多得的有力工具。
    `,
    mclusterP2: `
    MCluster另外方面的应用为超大体系的第一性原理计算。我们发现使用48个GPU能够计算高达5000个原子（20000个电子以上）的体系，
          其中一个典型的例子就是5120个Si原子的体系。在“MCluster”上，这样一个体系自洽计算足够收敛，仅仅需要3个小时。为了证明PWmat对大体系计算的准确性，我们计算了一个带点缺陷的4096
          Si原子的体材料体系 （见图），计算了该缺陷体系中费米面附近部分占据态（open shell）上电子的波函数，如下图2所示。另外我们也对1000个水分子（3000个原子，见图）的体系进行了
          第一性原理的分子动力学模拟：每一步分子动力学仅需要2.5分钟。这样的速度十分令人鼓舞，它已经接近原子基组方法的模拟规模和速度，但却不必担心可能由于基组不准而带来的误差。
          上面的例子是至今为止最大的平面波系统计算之一。比如2011年Gordon Bell prize, 计算了一个10,000 个Si原子的量子线，用了实空间方法，用的n1,n2,n3 要比我们5000 Si 原子的n1,n2,n3 小八倍，
           在当时世界最大的日本超级计算机“京””上计算，做一个自洽计算还需要24 小时。又比如，2006年的Gordon Bell prize，用平面波程序Qbox计算了一个1000 原子molybdenum的系统，
           总共有12,000 电子，用了整个BlueGene/L机器(当时世界上最快的计算机， 65,536 nodes）， 每一步自洽计算大致需要220秒 （按每一步SCF自洽由4步steepest decent steps 组成来估计）。
           相反，我们的Mcluster+PWmat, 计算一个3000 原子的Si 系统， 也是12,000 电子，每一步自洽计算只需要100秒 。 对于现有的开源和商业平面波基组模拟计算软件，
           要完成这样的超大体系计算也并不容易，甚至无法实现。例如在众所周知的广州超算“天河二号”上，通过对公认最强的商业平面波计算软件进行反复测试，我们发现无论使用多少核（最大到几千核），
           4000个Si原子的体系始终无法运行，最多只能运行2000到3000个Si原子。使用2000个CPU来计算这个2000 个Si原子系统，使用默认的设置，此软件需要至少半个小时才能完成整个自洽计算。
           但同样的系统和任务，在MCluster+PWmat上来计算，总共只需要8分钟。具体测试数据详见下面表格：
    `,
    mcloud: '超算云Mcloud',
    mcloudR0C1: '测试体系',
    mcloudR0C2: '原子数',
    mcloudR0C3: '电子数',
    mcloudR0C4: '截断能(eV)',
    mcloudR0C5: '赝势',
    mcloudR0C6: '时间（充分收敛）',
    mcloudR1C6: '3小时',
    mcloudR2C6: '1小时',
    mcloudR3C6: '3小时',
    mcloudR4C6: '22分钟',
    mcloudR5C6: '42分钟',
    mcloudR6C6: '7分钟',
    mcloudR7C6: '16分钟',
    mcloudR8C6: '150秒一步MD',
    mcloudR9C6: '840秒一步MD',
    mcloudP1: `
    Mcloud是由龙讯旷腾搭建的高性能集群和云桌面组成的超算云平台，2.0版本已于2022年4月1日成功上线，云平台集成了 PWmat、Q-Flow、Q-Studio以及Lammps等软件，提供SaaS材料模拟计算服务，用户
可以自主完成注册，注册之后即可在线使用PWmat等软件和丰富 GPU 卡时资源。Q-Flow 是龙讯旷腾推出 PWmat 可视化操作界面，将第一性原理计算图形化，把 PWmat 的功能模块分解为不同计算单元，用户通过过拽这些计算单元，连接成为工作流，即可完成不同性质计算。
Q-Studio 是基于 jsmol 开发的在线建模工具，用户无需要安装任何软件，只需要打开浏览器就可以完成在线建模。Mcloud 注册及登陆地址为：
    `,
  }
}